export const GROUP_MEMBERSHIPS = 'GM';
export const USA = 'us';